import './paging.scss'
import templateUrl from './paging.html'

/**
 * Modifies bw.paging.
 *
 * @type {ngDecorator}
 */
function pagingDirectiveDecorator($delegate, $translate) {
  'ngInject'
  let prevLink = $delegate[0].link

  $delegate[0].compile = compile
  $delegate[0].templateUrl = templateUrl // Use our template system.

  delete $delegate[0].link
  delete $delegate[0].template

  return $delegate

  // Translate labels and set different default values.
  function compile() {
    function link(scope, el, attrs) {
      if (scope.textTitleFirst === undefined) {
        $translate('PAGING.FIRST').then(
          translation => (scope.textTitleFirst = translation)
        )
      }
      if (scope.textTitleNext === undefined) {
        $translate('PAGING.NEXT').then(
          translation => (scope.textTitleNext = translation)
        )
      }
      if (scope.textTitlePage === undefined) {
        $translate('PAGING.CURRENT').then(
          translation => (scope.textTitlePage = translation)
        )
      }
      if (scope.textTitlePrev === undefined) {
        $translate('PAGING.PREV').then(
          translation => (scope.textTitlePrev = translation)
        )
      }
      if (scope.textTitleLast === undefined) {
        $translate('PAGING.LAST').then(
          translation => (scope.textTitleLast = translation)
        )
      }

      scope.activeClass = scope.activeClass ?? 'md-raised'
      scope.adjacent = scope.adjacent ?? 1
      scope.textPrev = scope.textPrev ?? '«'
      scope.textNext = scope.textNext ?? '»'
      attrs.hideIfEmpty = attrs.hideIfEmpty ?? 'true'
      attrs.showPrevNext = attrs.showPrevNext ?? 'true'
      prevLink.apply(null, arguments)
    }
    return link
  }
}

export let decorator = ['pagingDirective', pagingDirectiveDecorator]
